import React, {useState} from "react";
import { Box, Stack, Button, Typography } from "@mui/material";

import Area_Icon from "../../../images/Area_Icon.png";
import EditIcon from "@mui/icons-material/Edit";
import AreaSettingModal from "./modals/AreaSettingModal";

const NoAreas = ({ refetch }) => {
  const [openAreaSettingModal, setOpenAreaSettingModal] = useState(false);

  const handleOpen = () => setOpenAreaSettingModal(true);
  const closeAreaSettingModal = () => setOpenAreaSettingModal(false);

  return (
    <Stack
      justifyContent="center"
      alignItems="center"
      sx={{ height: 400 }}
    >
      <Box>
        <img src={Area_Icon} alt="Area Icon"></img>
      </Box>
      <Box sx={{ textAlign: "center" }}>
        <Typography>
          You currently don't have any saved Areas.<br></br>Let's start by
          creating an Area
        </Typography>
      </Box>
      <Box sx={{ mt: 2 }}>
        <Button
          onClick={handleOpen}
          startIcon={
            <EditIcon
              sx={{
                border: 1,
                borderRadius: 1,
                bgcolor: "white",
                borderColor: "white",
                color: "black",
              }}
            />
          }
          disableElevation
          fullWidth
          variant="contained"
          sx={{
            color: "white",
            height: 55,
            fontSize: "1rem",
          }}
        >
          Create Areas
        </Button>
        <AreaSettingModal
          openAreaSettingModal={openAreaSettingModal}
          closeAreaSettingModal={closeAreaSettingModal}
          refetch={refetch}
        />
      </Box>
    </Stack>
  );
};

export default NoAreas;
